import React, { useState } from 'react';
import { ChevronLeft, Download, Printer, Filter, Search, FileText, Calendar, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FormationDecisionsArchive() {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterDate, setFilterDate] = useState('');
  const [filterType, setFilterType] = useState('');
  const [filterAuthority, setFilterAuthority] = useState('');
  // Mock data for formation decisions
  const formationDecisions = [{
    id: 1,
    decisionNumber: 'DEC-2023-001',
    committee: 'Governance Committee',
    type: 'Parent',
    date: '2023-01-15',
    authority: 'Board of Directors',
    authorizedBy: 'Ahmed Al Dhaheri',
    status: 'Implemented',
    document: 'governance_committee_formation.pdf'
  }, {
    id: 2,
    decisionNumber: 'DEC-2023-002',
    committee: 'Finance Committee',
    type: 'Standard',
    date: '2023-02-10',
    authority: 'Executive Management',
    authorizedBy: 'Mohammed Al Hashimi',
    status: 'Implemented',
    document: 'finance_committee_formation.pdf'
  }, {
    id: 3,
    decisionNumber: 'DEC-2023-003',
    committee: 'Board Governance Team',
    type: 'Sub-Committee',
    date: '2023-03-05',
    authority: 'Governance Committee',
    authorizedBy: 'Aisha Al Mansoori',
    status: 'Implemented',
    document: 'board_governance_team_formation.pdf'
  }, {
    id: 4,
    decisionNumber: 'DEC-2023-004',
    committee: 'HR Committee',
    type: 'Standard',
    date: '2023-03-20',
    authority: 'Executive Management',
    authorizedBy: 'Fatima Al Zaabi',
    status: 'Implemented',
    document: 'hr_committee_formation.pdf'
  }, {
    id: 5,
    decisionNumber: 'DEC-2023-005',
    committee: 'IT Committee',
    type: 'Standard',
    date: '2023-04-12',
    authority: 'Executive Management',
    authorizedBy: 'Omar Al Shamsi',
    status: 'Implemented',
    document: 'it_committee_formation.pdf'
  }, {
    id: 6,
    decisionNumber: 'DEC-2023-006',
    committee: 'Regulatory Compliance Team',
    type: 'Sub-Committee',
    date: '2023-05-08',
    authority: 'Governance Committee',
    authorizedBy: 'Khalid Al Mazrouei',
    status: 'Implemented',
    document: 'regulatory_compliance_team_formation.pdf'
  }, {
    id: 7,
    decisionNumber: 'DEC-2023-007',
    committee: 'Quality Assurance Committee',
    type: 'Standard',
    date: '2023-06-15',
    authority: 'Executive Management',
    authorizedBy: 'Noura Al Suwaidi',
    status: 'Implemented',
    document: 'quality_assurance_committee_formation.pdf'
  }];
  // Filter decisions based on search and filter criteria
  const filteredDecisions = formationDecisions.filter(decision => {
    return (searchTerm === '' || decision.committee.toLowerCase().includes(searchTerm.toLowerCase()) || decision.decisionNumber.toLowerCase().includes(searchTerm.toLowerCase())) && (filterDate === '' || decision.date.includes(filterDate)) && (filterType === '' || decision.type === filterType) && (filterAuthority === '' || decision.authority === filterAuthority);
  });
  // Get unique values for filter dropdowns
  const uniqueTypes = [...new Set(formationDecisions.map(d => d.type))];
  const uniqueAuthorities = [...new Set(formationDecisions.map(d => d.authority))];
  return <div data-id="element-775">
      <div className="flex items-center mb-6" data-id="element-776">
        <Link to="/committees" className="flex items-center text-gray-600 hover:text-gray-900 mr-4" data-id="element-777">
          <ChevronLeft size={20} className="mr-1" data-id="element-778" />
          Back to Committees
        </Link>
        <h1 className="text-2xl font-bold" data-id="element-779">Formation Decisions Archive</h1>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6" data-id="element-780">
        <div className="text-gray-600 mb-4" data-id="element-781">
          <p data-id="element-782">
            This archive contains all historical decisions related to committee
            formations. Use the filters below to narrow your search.
          </p>
        </div>
        {/* Search and Filters */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6" data-id="element-783">
          <div className="md:col-span-2" data-id="element-784">
            <div className="relative" data-id="element-785">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} data-id="element-786" />
              <input type="text" placeholder="Search by committee name or decision number..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-787" />
            </div>
          </div>
          <div data-id="element-788">
            <div className="relative" data-id="element-789">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-790">
                Date
              </label>
              <input type="date" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={filterDate} onChange={e => setFilterDate(e.target.value)} data-id="element-791" />
            </div>
          </div>
          <div data-id="element-792">
            <div className="relative" data-id="element-793">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-794">
                Committee Type
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={filterType} onChange={e => setFilterType(e.target.value)} data-id="element-795">
                <option value="" data-id="element-796">All Types</option>
                {uniqueTypes.map((type, index) => <option key={index} value={type} data-id="element-797">
                    {type}
                  </option>)}
              </select>
            </div>
          </div>
          <div data-id="element-798">
            <div className="relative" data-id="element-799">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-800">
                Decision Authority
              </label>
              <select className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500" value={filterAuthority} onChange={e => setFilterAuthority(e.target.value)} data-id="element-801">
                <option value="" data-id="element-802">All Authorities</option>
                {uniqueAuthorities.map((authority, index) => <option key={index} value={authority} data-id="element-803">
                    {authority}
                  </option>)}
              </select>
            </div>
          </div>
        </div>
        {/* Results Table */}
        <div className="overflow-x-auto" data-id="element-804">
          <table className="w-full" data-id="element-805">
            <thead data-id="element-806">
              <tr className="bg-gray-50" data-id="element-807">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-808">
                  Decision Number
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-809">
                  Committee
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-810">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-811">
                  Date
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-812">
                  Authority
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-813">
                  Authorized By
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-814">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-815">
              {filteredDecisions.map(decision => <tr key={decision.id} className="hover:bg-gray-50" data-id="element-816">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-817">
                    <div className="font-medium text-gray-900" data-id="element-818">
                      {decision.decisionNumber}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-819">
                    <div className="font-medium text-gray-900" data-id="element-820">
                      {decision.committee}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-821">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${decision.type === 'Parent' ? 'bg-blue-100 text-blue-800' : decision.type === 'Sub-Committee' ? 'bg-purple-100 text-purple-800' : 'bg-green-100 text-green-800'}`} data-id="element-822">
                      {decision.type}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-823">
                    <div className="flex items-center" data-id="element-824">
                      <Calendar size={16} className="text-gray-500 mr-2" data-id="element-825" />
                      <span data-id="element-826">{decision.date}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-827">
                    {decision.authority}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-828">
                    {decision.authorizedBy}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-829">
                    <div className="flex space-x-3" data-id="element-830">
                      <button className="text-blue-500 hover:text-blue-700" title="View Decision" data-id="element-831">
                        <FileText size={18} data-id="element-832" />
                      </button>
                      <button className="text-green-500 hover:text-green-700" title="Download" data-id="element-833">
                        <Download size={18} data-id="element-834" />
                      </button>
                      <button className="text-purple-500 hover:text-purple-700" title="Print" data-id="element-835">
                        <Printer size={18} data-id="element-836" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {filteredDecisions.length === 0 && <div className="text-center py-8" data-id="element-837">
            <p className="text-gray-500" data-id="element-838">
              No formation decisions match your search criteria.
            </p>
          </div>}
      </div>
    </div>;
}